<script setup>
  import { ref } from 'vue'

  import { useDevModeStore } from '@/features/devMode/useDevModeStore.js'
  import { useLayoutStore } from '@/features/layout/useLayoutStore.js'

  const isOpened = ref(false)

  function handleClickOpener() {
    isOpened.value = !isOpened.value
  }

  const layoutStore = useLayoutStore()
  const devModeStore = useDevModeStore()

  function handlePermissionDebugChange(event) {
    devModeStore.setPermissionDebugEnabled(event.target.checked)
  }
</script>

<template>
  <div v-if="devModeStore.isDevMode" class="dev-mode-opener">
    <span class="trigger" @click="handleClickOpener"
      >[Dev]

      <span v-if="isOpened">X</span>
    </span>
    <div v-if="isOpened">
      <div class="buttons">
        <button type="button" @click="layoutStore.setTheme('generic')">default</button>
        <button type="button" @click="layoutStore.setTheme('helloclub')">hello</button>
      </div>

      <br />

      <label class="debug-toggle">
        <input
          type="checkbox"
          :checked="devModeStore.permissionDebugEnabled"
          @change="handlePermissionDebugChange"
        />
        <span>fmPermissionDebug</span>
      </label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .dev-mode-opener {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9999;
    background: red;
    color: #fff;
    padding: 4px;
    font-size: 11px;
    border-bottom-left-radius: 5px;
  }

  .trigger {
    cursor: pointer;
  }

  .buttons {
    display: flex;
    gap: 5px;
  }

  .debug-toggle {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 6px;
    white-space: nowrap;
    cursor: pointer;
  }

  button {
    background: light-dark(#333, #cdcdcd);
    color: light-dark(#fff, #121212);
    border: 0;
    padding: 3px;
    margin: 0;
    cursor: pointer;

    &:hover {
      background: light-dark(#444, #bbbbbb);
    }
  }
</style>
